// Yes / No / To be decided fields on a trial: 1 = yes, 0 = no, 2 = to be decided (as Harvest)

export const TRI_STATE_FIELDS = ['Harvest', 'NIT', 'GerminationTest', 'TGW'];

export const TRI_STATE_OPTIONS = [
  { value: 2, label: 'To be decided' },
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' },
];

/** The value as 0, 1 or 2 (old boolean values too); null when not set. */
export function triStateValue(value) {
  if (value === true) return 1;
  if (value === false) return 0;
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return [0, 1, 2].includes(n) ? n : null;
}

/** The select's colours for a value: green (yes), red (no), yellow (to be decided). */
export function triStateClass(value) {
  const v = triStateValue(value);
  if (v === 1) return 'bg-green-100 text-green-700 border-green-300';
  if (v === 0) return 'bg-red-100 text-red-700 border-red-300';
  return 'bg-yellow-100 text-yellow-700 border-yellow-300';
}
